import { setDefaultValues, setToTopDimIds } from '../dimensionUtils'
export function createDefaultPivotConfig(dimensions) {
  let chart = 'bar-chart'
  let dimOptions = dimensions.dimensionOptions
  let metas = dimensions.dimensionMetas

  let pivotConfig
  pivotConfig = {
    dimensions: Object.keys(dimOptions).map(key => {
      let type = metas[key].type
      let role = type === 'time' ? 'columns' : type === 'location' ? 'rows' : 'filters'
      if (type === 'time') {
        role = 'filters'
      }
      return {
        id: key,
        role: role,
      }
    }),
  }

  Object.keys(metas).forEach(key => {
    if (metas[key].typeOptions.length > 0) {
      pivotConfig.dimensions.push({
        id: key + '_type',
        role: 'types',
      })
    }
  })

  let noTimeFilters = pivotConfig.dimensions.filter(
    d => d.role === 'filters' && metas[d.id].type !== 'time'
  )
  if (noTimeFilters.length > 0) {
    noTimeFilters[0].role = 'columns'
  }

  let filterDims = pivotConfig.dimensions.filter(d => d.role === 'filters')

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  let rowsDim = pivotConfig.dimensions.find(d => d.role === 'rows')
  if (metas[rowsDim.id].type === 'location' && rowsDim.values.length === 1) {
    if (filterDims.length > 0) {
      filterDims = filterDims.slice(0, 1)
      filterDims.forEach(d => (d.role = 'rows'))
      rowsDim.role = 'filters'
    } else {
      let colsDim = pivotConfig.dimensions.find(d => d.role === 'columns')
      rowsDim.role = 'columns'
      colsDim.role = 'rows'
    }
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  }

  //RELLENAMOS ROWS Y COLS

  // let rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
  let filetrsDims = pivotConfig.dimensions.filter(d => d.role === 'filters')
  let colsDims = pivotConfig.dimensions.filter(d => d.role === 'columns')

  let toCols

  if (colsDims.length === 1 && colsDims[0].values.length === 1) {
    colsDims[0].role = 'filters'
    toCols = filetrsDims.slice(0, 1) // [filetrsDims[0]]
    toCols.forEach(d => (d.role = 'columns'))
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  }

  setToTopDimIds(pivotConfig, metas)

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  return pivotConfig
}

export function getAvailability(dimensions) {
  let metas = Object.values(dimensions.dimensionMetas)
  let hasExtraDims = metas.filter(d => d.type !== 'time' && d.type !== 'location').length > 0
  return { enabled: hasExtraDims, enableable: hasExtraDims }
}

export function checkBadData(chartData) {
  return chartData && chartData.slice(1).every(d => d.slice(1).every(dd => !dd))
}
export default {
  getAvailability,
  createDefaultPivotConfig,
  checkBadData,
  maxChartDims: 2,
  maxRowDims: 1,
  sdvComponent: 'ConnectedDotPlot',
}
